import {
  base_colorAction,
  base_colorContentBorder,
  base_contentHover,
  cta_buttonSecondaryBackground,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

const LABEL_TOGGLE_HEIGHT = '40px'

export default css`
  display: inline-block;
  border-radius: 10px;

  .LabelToggle-container {
    display: flex;
    flex-direction: row;
    height: ${LABEL_TOGGLE_HEIGHT};
    align-items: center;
    padding: ${spacing(1)};
    gap: ${spacing(1)};
    background-color: ${cta_buttonSecondaryBackground};
    border-radius: 10px;
    border: 1px solid ${base_colorContentBorder};
  }

  .LabelToggle-option:hover {
    cursor: pointer;
  }

  .LabelToggle-option-label {
    border-radius: 10px;
    color: ${text_colorTextSecondary};
    /* Deviated from Figma. 2 is too much. 1 is not enough
       2 feels cramped. Due to fixed height of element we
       are a little restricted on space and Figma padding it at 7px
       which is not a standard number */
    padding: ${spacing(1)} ${spacing(3)};

    ${font_md}

    &.selected {
      border: 1px solid ${base_colorAction};
      background-color: ${base_contentHover};
      color: ${base_colorAction};
    }

    &:hover {
      cursor: pointer;
    }
  }

  .LabelToggle-option-radio {
    display: none;
  }
`
